export enum TenantDataResidencyEvent {
    ReadMore = 'TenantDataResidency.ReadMore',
}
